import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteAuthorizedDriver } from '../../services/VehiclesService';
import { VehicleAuthorizedDrivers, VehicleAuthorizedDriverDeleteRequest } from '../../types/Vehicles';

type Result = UseMutationResult<VehicleAuthorizedDrivers, Error, VehicleAuthorizedDriverDeleteRequest>;

function useDeleteAuthorizedDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteAuthorizedDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['authorized-drivers'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteAuthorizedDriver;
